import styled, { css } from 'styled-components';

import Badge from '@xcritical/badge';

import { colors } from '@crm-framework/theme';

export const MenuItem = styled.li`
  margin-bottom: 5px;
`;

export const StyledMenuIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    background-color: ${colors.SECONDARY_HOVER};
  }
`;

export const UnreadMessagesWrapper = styled.div.attrs({
  className: 'chat__icon',
})`
  position: relative;
`;

export const UnreadMessages = styled(Badge).attrs({
  className: 'chat__icon-unread',
})`
  color: #fff;
  background-color: ${colors.R6};
  position: absolute;
  top: -5px;
  left: 15px;
`;

export const AnimatedWrapper = styled.div<{
  enable?: boolean;
}>`
  border-radius: 50%;
  height: 30px;
  width: 30px;
  transform: scale(1);

  ${({ enable }) =>
    enable
      ? css`
          animation: AnimatedWrapperPulse 2s infinite;
          box-shadow: 0 0 0 0 ${colors.DANGER};
          background: ${colors.DANGER};
        `
      : ''}

  justify-content: center;
  align-items: center;
  align-content: stretch;
  display: flex;

  @keyframes AnimatedWrapperPulse {
    0% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
    }

    70% {
      transform: scale(1);
      box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
    }

    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
    }
  }
`;
